class MemberGalleryHandler {
    constructor() {
        const members = document.querySelectorAll(".member-gallery__member");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("in-view");
                } else {
                    entry.target.classList.remove("in-view");
                }
            });
        }, {
            root: null,
            threshold: 1,
            rootMargin: "0px 0px -25% 0px",
        });

        members.forEach(member => {
            observer.observe(member);
        });
    }
}

export default MemberGalleryHandler;
